export default __webpack_public_path__ + "static/logo-brookhaven-a2c82776bfb72de284918974e8c4b564.png";